import type { IRentalDispenseMaterialization } from "@/interfaces/api/rental-dispense-materialization.interface.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { RentalDispense } from "@/models/rental-dispense.model.ts"
import { RentalMaterialization } from "@/models/rental-materialization.model.ts"

export class RentalDispenseMaterialization
  extends RentalMaterialization
  implements IRentalDispenseMaterialization
{
  public static className = "RentalDispenseMaterialization"
  public static verboseName = "Verhuurmaterialisatie"

  rentalMutation: RentalDispense
  productionStatement?: string
  productionStatementCreationJob?: string
  productionStatementReference?: string

  constructor(rentalDispenseMaterialization: IRentalDispenseMaterialization, managed = false) {
    super(rentalDispenseMaterialization)

    this.rentalMutation = ModelFactory.childModel(
      RentalDispense,
      rentalDispenseMaterialization.rentalMutation,
      managed
    )
    this.productionStatement = rentalDispenseMaterialization.productionStatement
    this.productionStatementCreationJob =
      rentalDispenseMaterialization.productionStatementCreationJob
    this.productionStatementReference = rentalDispenseMaterialization.productionStatementReference
  }

  /** Locked while linked to a production statement or reserved by a creation job generating one. */
  public isLocked(): boolean {
    return Boolean(this.productionStatement || this.productionStatementCreationJob)
  }
}
